import React, { useEffect } from "react";
import styles from "./BOMOnePrint.module.css";
import logo from "../../../assets/images/coyote-logo.jpg";

const BOMOne = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className={styles.bomBody}>
        <div className={styles.bomContainer}>
          <div className={styles.printButtonContainer}>
            <button onClick={handlePrint} className={styles.printButton}>
              Print BOM Report
            </button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "20px",
              borderBottom: "3px solid #0056b3",
              paddingBottom: "10px",
            }}
          >
            <div className="coyote-logo">
              <img
                className="coyote-logo-image"
                src={logo}
                alt="coyote-logo"
                style={{ height: "auto", width: "120px" }}
              />
            </div>
            <div
              className={styles.bomReportTitle}
              style={{ textAlign: "right" }}
            >
              <h1>BILL OF MATERIALS (BOM)</h1>
              <p>
                BOM Number:{" "}
                <span style={{ fontWeight: "bold" }}>BOM-2025-478</span>
              </p>
            </div>
          </div>

          <div className={styles.bomMetadataBox}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <div style={{ flex: "1", paddingRight: "20px", fontSize: "9pt" }}>
                <span className={styles.bomMetadataLabel}>Project/Job:</span>{" "}
                Downtown Office Retrofit (J-0051)
              </div>
              <div style={{ flex: "1", paddingRight: "20px", fontSize: "9pt" }}>
                <span className={styles.bomMetadataLabel}>
                  Receiving Warehouse:
                </span>{" "}
                Main Distribution Center (WH-01)
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <div style={{ flex: "1", paddingRight: "20px", fontSize: "9pt" }}>
                <span className={styles.bomMetadataLabel}>Prepared By:</span>{" "}
                Jane Doe
              </div>
              <div style={{ flex: "1", paddingRight: "20px", fontSize: "9pt" }}>
                <span className={styles.bomMetadataLabel}>Date Generated:</span>{" "}
                October 29, 2025
              </div>
            </div>
          </div>

          <h3 className={styles.bomDetailedHeading}>Detailed Requirements</h3>
          <div className={styles.bomTableWrapper}>
            <table className={styles.bomDataTable}>
              <thead>
                <tr>
                  <th>Phase</th>
                  <th>Product (Model/SKU)</th>
                  <th>Unit</th>
                  <th>Manufacturer</th>
                  <th>Qty Req</th>
                  <th>In Stock</th>
                  <th>Allocated*</th>
                  <th>Available</th>
                  <th>To Order</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Rough-in</td>
                  <td>12/2 Gauge Cable (CW-122)</td>
                  <td>ft</td>
                  <td>Belden</td>
                  <td>500</td>
                  <td>400</td>
                  <td>0</td>
                  <td className={styles.bomStatusAvailable}>400</td>
                  <td className={styles.bomQtyOrder}>100</td>
                  <td>BACKORDER</td>
                </tr>
                <tr>
                  <td>Fit-out</td>
                  <td>IP Security Camera (CAM-200)</td>
                  <td>cm</td>
                  <td>Axis</td>
                  <td>5</td>
                  <td>1</td>
                  <td>0</td>
                  <td className={styles.bomStatusShortage}>1</td>
                  <td className={styles.bomQtyOrder}>4</td>
                  <td>BACKORDER</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3
            className={styles.bomDetailedHeading}
            style={{ marginTop: "30px" }}
          >
            In-Stock Products
          </h3>
          <div className={styles.bomTableWrapper}>
            <table className={styles.bomDataTable}>
              <thead>
                <tr>
                  <th>Phase</th>
                  <th>Product (Model/SKU)</th>
                  <th>Unit</th>
                  <th>Manufacturer</th>
                  <th>Qty Req</th>
                  <th>In Stock</th>
                  <th>Allocated*</th>
                  <th>Available</th>
                  <th>To Order</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Rough-in</td>
                  <td>Outlet Box (OB-4X4)</td>
                  <td>ft</td>
                  <td>Hubbell</td>
                  <td>80</td>
                  <td>120</td>
                  <td>10</td>
                  <td className={styles.bomStatusAvailable}>110</td>
                  <td className={styles.bomQtyOrder}>0</td>
                  <td>Aisle 3 / R-A</td>
                </tr>
                <tr>
                  <td>Finishing</td>
                  <td>LED Panel Light (LED-600)</td>
                  <td>cm</td>
                  <td>Cree</td>
                  <td>25</td>
                  <td>30</td>
                  <td>0</td>
                  <td className={styles.bomStatusAvailable}>30</td>
                  <td className={styles.bomQtyOrder}>0</td>
                  <td>Aisle 4 / R-D</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={styles.bomFooter}>
            <p>
              *Qty Allocated: Quantity reserved by other active Bill of
              Materials. Stock status is based on real-time inventory at the
              time of report generation and is subject to change.
            </p>
          </div>

          <div className={styles.bomSignatureSection}>
            <div className={styles.bomSignatureBox}>
              <div className={styles.bomSignatureTitle}>Prepared By:</div>
              <div className={styles.bomSignatureLine}>
                <span>Name / Title</span>
                <div className={styles.bomLine}></div>
              </div>
              <div className={styles.bomSignatureLine}>
                <span>Signature</span>
                <div className={styles.bomLine}></div>
              </div>
              <div className={styles.bomSignatureLine}>
                <span>Date</span>
                <div className={styles.bomLine}></div>
              </div>
            </div>

            <div className={styles.bomSignatureBox}>
              <div className={styles.bomSignatureTitle}>Approved By:</div>
              <div className={styles.bomSignatureLine}>
                <span>Name / Title</span>
                <div className={styles.bomLine}></div>
              </div>
              <div className={styles.bomSignatureLine}>
                <span>Signature</span>
                <div className={styles.bomLine}></div>
              </div>
              <div className={styles.bomSignatureLine}>
                <span>Date</span>
                <div className={styles.bomLine}></div>
              </div>
            </div>
          </div>

          <div className={styles.bomCompanyFooter}>
            Coyote Cabling, Inc. • 123 Copper Way, Dallas, TX 75201 •
            procurement@coyotecabling.com
          </div>
        </div>
      </div>
    </>
  );
};

export default BOMOne;
